import { useSelector } from "react-redux";

const useWorkerMovementData = () => {
	const scheduleConfiguration = useSelector(
		(state: any) => state.gatAdminConfiguration.getScheduleConfiguration.data
	);

	const scheduleConfigurationStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.getScheduleConfiguration.status
	);

	const scheduleConfigurationError = useSelector(
		(state: any) => state.gatAdminConfiguration.getScheduleConfiguration.errorMessage
	);

	const updateScheduleConfigurationStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.updateScheduleConfiguration.status
	);

	const updateScheduleConfigurationError = useSelector(
		(state: any) => state.gatAdminConfiguration.updateScheduleConfiguration.errorMessage
	);

	const workerTypes = useSelector(
		(state: any) => state.gatAdminConfiguration.workerTypes
	);

	const workerTypesStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.getWorkerTypes.status
	);

	const workerSubTypes = useSelector(
		(state: any) => state.gatAdminConfiguration.getWorkerSubType.data
	);

	const workerSubTypesStatus = useSelector(
		(state: any) => state.gatAdminConfiguration.getWorkerSubType.status
	);

	const companyData = useSelector(
		(state: any) => state.gatAdminConfiguration.companyData
	);

	const companyId = companyData?.id;

	return {
		scheduleConfiguration,
		scheduleConfigurationStatus,
		scheduleConfigurationError,
		updateScheduleConfigurationStatus,
		updateScheduleConfigurationError,
		workerTypes,
		workerTypesStatus,
		workerSubTypes,
		workerSubTypesStatus,
		companyId,
	};
};

export default useWorkerMovementData;
